import { prop, propObject, required } from "@rxweb/reactive-form-validators";
import { Resource } from "src/app/core/jsonapi/resource";
import { CalendarEventType } from "./calendar-event-type";
import { CalendarEventScope } from "./calendar-event-scope";
import { Calendar } from "./calendar";

export class CalendarEvent extends Resource {
    public override type = 'calendarEvents';

    @prop()
    @required()
    public calendarId!: string;

    @prop()
    @required()
    public date!: string;

    @prop()
    public description!: string;

    @prop()
    public calendarEventTypeId!: string;
    public calendarEventType!: CalendarEventType;

    @prop()
    public scopeId?: string;

    @propObject(CalendarEventScope)
    public scope?: CalendarEventScope;

    @prop()
    public start!: any;

    @prop()
    public end!: any;
    
    @propObject(Calendar)
    public calendar?: Calendar;


}